// extracted by mini-css-extract-plugin
export default {"medicinesContainer":"AllMedicinespage__medicinesContainer__usAKW","cardContainer":"AllMedicinespage__cardContainer__tozds"};
    if(module.hot) {
      // 1763020726957
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  